import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const CookieConsent: React.FC = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const cookieChoice = localStorage.getItem('cookieConsent');
    if (!cookieChoice) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = (essential: boolean = true, analytics: boolean = true) => {
    localStorage.setItem('cookieConsent', JSON.stringify({
      essential: essential, // Always true as these are necessary
      analytics: analytics,
      timestamp: new Date().toISOString()
    }));
    setShowBanner(false);
  };

  const handleReject = () => {
    // Still store essential cookies as they're necessary for the app to function
    handleAccept(true, false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white p-4 shadow-lg z-50">
      <div className="container mx-auto max-w-6xl">
        <div className="space-y-4">
          <div className="text-sm">
            <p className="mb-2">
              We use cookies to provide essential functionality and improve your experience. 
              By continuing to use our system, you agree to our use of cookies.
            </p>
            {showDetails && (
              <div className="mt-4 space-y-2 text-sm bg-gray-800 p-4 rounded-md">
                <h4 className="font-semibold">Cookie Types:</h4>
                <ul className="list-disc list-inside space-y-1">
                  <li>Essential Cookies: Required for basic site functionality (authentication, preferences)</li>
                  <li>Analytics Cookies: Help us understand how visitors interact with our site</li>
                </ul>
              </div>
            )}
            <button
              onClick={() => setShowDetails(!showDetails)}
              className="text-blue-300 hover:text-blue-400 underline mt-2"
            >
              {showDetails ? 'Hide Details' : 'Show Details'}
            </button>
            {' | '}
            <Link to="/privacy" className="text-blue-300 hover:text-blue-400 underline">
              Privacy Policy
            </Link>
          </div>
          <div className="flex flex-wrap gap-4">
            <button
              onClick={() => handleAccept()}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md text-sm font-medium transition-colors"
            >
              Accept All
            </button>
            <button
              onClick={handleReject}
              className="bg-gray-600 hover:bg-gray-700 text-white px-6 py-2 rounded-md text-sm font-medium transition-colors"
            >
              Essential Only
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
